import OSS from 'ali-oss'
import store from '@/store'
import { OSS_BUCKET, OSS_REGION } from '@/constant/common'
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

export function generateTempFileKey (fileExt) {
  return `resume/temp/${uuidv4()}.${fileExt}`
}

export function getFileExtension (file) {
  const fileName = file instanceof File ? file.name : String(file).trim()
  if (!fileName) return ''
  const lastDotIndex = _.lastIndexOf(fileName, '.')
  if (lastDotIndex <= 0 || lastDotIndex === fileName.length - 1) {
    return ''
  }
  return _.toLower(fileName.slice(lastDotIndex + 1))
}

export async function createOSSClient () {
  const tokenInfo = await store.dispatch('common/getOSSUploadToken')
  return new OSS({
    bucket: OSS_BUCKET,
    region: OSS_REGION,
    authorizationV4: true,
    accessKeyId: tokenInfo.access_key_id,
    accessKeySecret: tokenInfo.access_key_secret,
    stsToken: tokenInfo.security_token
  })
}

export async function uploadFile (file, fileKey) {
  const client = await createOSSClient()
  return client.put(fileKey, file)
}
